$(document).ready(function() {
      getHeaderHeight();
  });
  function getHeaderHeight(){
    var classHeaderHeight = jQuery('body').width();
    document.documentElement.style.setProperty('--screen-size', classHeaderHeight+'px');
  }

$(window).on('resize', function () {
  getHeaderHeight();
})

//:: start :: drawer menu scripts :: ==================
jQuery(".header__icon--menu").click(function(){
    //console.log("menu open");
    if(!jQuery('.menu-drawer-container').hasClass('menu-opening')){
      jQuery('body').addClass('menu-open');
    }
});
jQuery(".drawer-closer").click(function () {
  //console.log("menu close");
  jQuery(".header__icon--menu").trigger("click");
  jQuery('body').removeClass('menu-open');
});
//:: end :: drawer menu scripts :: ==================

//:: start :: Cart look product  scripts :: ==================
$(document).ready(function() {
  var $slider1 = $('.cartlook-slick');
  var $progressBar1 = $('.progresslook');
  var $progressBarLabel1 = $( '.slider--label' );
  
  $slider1.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar1
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel1.text( calc + '% completed' );
  });
  
  $slider1.slick({
    centerMode: false,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    infinite: false,
    dots:false,
    arrows:true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M25 30.4316L15 20.4316L25 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M15 30.4316L25 20.4316L15 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  });  
});
//:: end :: Cart look product  scripts :: ==================

//:: start :: product page try now scripts :: ==================
$(document).ready(function() {
  var $slider = $('.other-flavors-slick');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    centerMode: false,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    infinite: false,
    dots:false,
    arrows:true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M25 30.4316L15 20.4316L25 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M15 30.4316L25 20.4316L15 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  });  
});
//:: end :: product page try now scripts :: ==================

//:: start :: logo marquee scripts :: ==================
$('.logo_marquee_slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    }
  ]
});
//:: end :: logo marquee scripts :: ==================

//:: start :: review slider scripts :: ==================
$('.review__slider').slick({
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots:true,
  arrows:true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M25 30.4316L15 20.4316L25 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><path d="M15 30.4316L25 20.4316L15 10.4316" stroke="black" stroke-width="2.5"/></path></svg></button>',
  responsive: [
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 575,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      centerMode: true,
      infinite: true,
    }
  }
]
});
//:: end :: review slider scripts :: ==================

//:: START :: image marquee scripts :: ==================
$('.image_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
//:: END :: image marquee scripts :: ==================

//:: START :: Collection product item add to cart  :: ==================
function addItemCart(Quantity,variantId){
   $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
        quantity: Quantity,
        id: variantId
    },
    success: function(cart) {
      
    },
    error: function(response) {
        alert(response);
    }
  });
}

jQuery(document).on('change','.add__select_custom',function(){
  var variantId = jQuery(this).val();
  $(this).parent().find('.product-variant-id').val(variantId);
  $(this).hide();
  $(this).parent().find('.add__custom_loader').show();
  $(this).parent().find('.quick-add__submit').trigger('click');
});

jQuery(document).on('click','.add__btn_custom_button',function(){
  $(this).parent().find('.add__custom_loader').show();
  $(this).parent().find('.quick-add__submit').trigger('click');
});
//:: END :: Collection product item add to cart  :: ==================


//product page look up item start
jQuery(document).on('change','.add_pro_try_sel',function(){
  var variantId = jQuery(this).val();
  $(this).parent().find('[name="id"]').val(variantId);
  $(this).hide();
  $(this).parent().find('.add__custom_loader').show();
  $(this).parent().find('[name="add"]').trigger('click');
});

//product page look up item end

//:: START :: Collapsible panels  :: ==================
document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".home_faq_item-header"
  );
  const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

  // Open the first accordion item by default
  /* firstAccordionItemHeader.classList.add("active");
  firstAccordionItemBody.style.maxHeight =
    firstAccordionItemBody.scrollHeight + "px";  */

  const accordionItemHeaders = document.querySelectorAll(
    ".home_faq_item-header"
  );

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".home_faq_item-header.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
});

/* on click button panel hide */
document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.faq-buttons .button');
    const panels = document.querySelectorAll('.faqwrapper-grid');

    // Function to show the panel associated with a button
    function showPanel(label) {
        panels.forEach(panel => panel.style.display = 'none'); // Hide all panels
        const targetPanel = document.querySelector(`.faqwrapper-grid[data-panels-label="${label}"]`);
        if (targetPanel) {
            targetPanel.style.display = 'flex'; // Show the target panel
        }
    }

    // Set up event listeners for buttons
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            const targetLabel = this.id;

            // Remove 'active' class from all buttons
            buttons.forEach(btn => btn.classList.remove('active'));

            // Add 'active' class to the clicked button
            this.classList.add('active');

            // Show the panel corresponding to the clicked button
            showPanel(targetLabel);
        });
    });

    // Set default active button and panel on page load
    const defaultButton = document.querySelector('.faq-buttons .button.active');
    if (defaultButton) {
        showPanel(defaultButton.id);
    }
});
//:: END :: Collapsible panels :: ==================


//:: START :: Cart progress  :: ==================
var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
var formatCurrency = window.theme.moneyFormat;
setInterval(function(){
 if(jQuery('.drawer.active').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      console.log("totalCart",totalCart);
      if(cartData.length>0){
        subTotal = cart.original_total_price;
        var percentage_reached = (eval(subTotal) / eval(goalAmount));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
      
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }else{
          jQuery('.cart_shipping_box').hide();
        }
        
      
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += customMoney(goalPendingAmount, );
          tempStr += '</span>'
          tempStr += goalAfterText;
        }
        else{
          tempStr += goalReachText;
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M8.28479 20.6111C7.62562 20.6111 7.06696 20.3872 6.60881 19.9393C6.15005 19.4909 5.92067 18.9463 5.92067 18.3056H4.66663V9.59055C4.66663 9.18499 4.80637 8.84644 5.08585 8.57489C5.36472 8.30275 5.71272 8.16669 6.12983 8.16669H18.1089V11.3538H20.1986L23.3333 15.457V18.3056H21.8701C21.8701 18.9463 21.6395 19.4909 21.1783 19.9393C20.7172 20.3872 20.157 20.6111 19.4978 20.6111C18.8393 20.6111 18.2809 20.3872 17.8227 19.9393C17.364 19.4909 17.1346 18.9463 17.1346 18.3056H10.6571C10.6571 18.9498 10.4265 19.4953 9.96529 19.942C9.50352 20.3887 8.94335 20.6111 8.28479 20.6111ZM8.28841 19.7304C8.69586 19.7304 9.04174 19.5922 9.32605 19.316C9.60976 19.0392 9.75161 18.7024 9.75161 18.3056C9.75161 17.9089 9.60976 17.5724 9.32605 17.2961C9.04234 17.0199 8.69646 16.8818 8.28841 16.8818C7.88035 16.8818 7.53478 17.0199 7.25167 17.2961C6.96797 17.5724 6.82611 17.9089 6.82611 18.3056C6.82611 18.7024 6.96797 19.0389 7.25167 19.3151C7.53538 19.5914 7.88096 19.7304 8.28841 19.7304ZM19.5024 19.7295C19.9098 19.7295 20.2554 19.5914 20.5391 19.3151C20.8228 19.0389 20.9646 18.7024 20.9646 18.3056C20.9646 17.9089 20.8228 17.5724 20.5391 17.2961C20.2554 17.0199 19.9098 16.8818 19.5024 16.8818C19.0949 16.8818 18.7493 17.0199 18.4656 17.2961C18.1819 17.5724 18.0401 17.9089 18.0401 18.3056C18.0401 18.7024 18.1819 19.0389 18.4656 19.3151C18.7493 19.5914 19.0949 19.7295 19.5024 19.7295ZM18.1089 15.6607H22.3753L19.7115 12.2355H18.1089V15.6607Z" fill="black"/></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }
  });
 }
},1000);

function customMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || "${{amount}}";

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(
    number,
    precision,
    thousands,
    decimal
  ) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  var value = "";

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString
      .replace(placeholderRegex, value)
      .replace(",00", "");
  } else {
    return formatString
      .replace(placeholderRegex, value)
      .replace(".00", "");
  }
}

//:: END :: Cart progress  :: ==================

//cart look up item start
jQuery(document).on('change','.add__btn_custom_sel',function(){
  var variantId = jQuery(this).val();
  $(this).parent().find('cart-upsell-add-button').attr('data-vid', variantId);
  $(this).parent().find('cart-upsell-add-button').find('.upsell-add-button-cart').trigger('click');
});

var drawerInterval='';
jQuery(document).ready(function(){
  drawerInterval =setInterval(function(){
    if(jQuery('#CartDrawerMain').hasClass('active')){
      if(jQuery('.cart_lookitem_box  ').attr('display')=='block' || jQuery('.cart_lookitem_box  ').attr('display')==undefined){
        var upsellCount =  jQuery('.cart_lookitem_box  ').find('.upsell--item').length;
        var displayUpsell=0;
        jQuery('.cart_lookitem_box  ').find('.upsell--item').each(function(){
          if(jQuery(this).css('display')=='none'){
            displayUpsell++;
          }
        });  
        if(displayUpsell==upsellCount){
          jQuery('.cart_lookitem_box  ').hide();
        }else{
          jQuery('.cart_lookitem_box  ').show();
        }
      }
    }
  },1000);
});
//cart look up item end


//:: START :: Product galery  :: ==================

$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: false,
    dots: false,
    draggable: false,
    focusOnSelect: false,
});
$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 921,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 521,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
});
jQuery(document).on("click",".zoom-gallery",function(){
  jQuery('body').addClass("product-popup-open");
  jQuery('.product-media-modal').attr('open','');
});
jQuery(document).on("click",".product-media-modal__toggle",function(){
  jQuery('body').removeClass("product-popup-open");
});
jQuery(document).on("click",".hchoose-modal-button",function(){  
  jQuery('.hchoose-modal').addClass('js-modal-open');
});
jQuery(document).on('click',".hchoose-close",function(){
   jQuery('.hchoose-modal').removeClass('js-modal-open');
});
//:: END :: Product galery  :: ==================

jQuery(document).on("change",'input[name="selling_plan"]',function(){
  console.log("innn");
  if ($(this).is(':checked')) {
    var selectedValue = $(this).val(); 
    if(selectedValue != ''){
      console.log("Selected selling plan:", selectedValue);
      //setTimeout(function() {
        $(".appstle_include_dropdown.appstle-active-option .appstle_subscribe_option").append('<ul class="appstle-listing"><li>Free Shipping</li><li>Guaranteed delivery during sell-outs</li><li>Pause, update frequency or cancel anytime</li></ul>');
      //}, 1500);
    }
    else{
      $('.appstle-listing').remove();
    }
  }
});



// Select the video element
/* const video = document.getElementById('product-video-meta');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      video.play();
    } else {
      video.pause(); 
      }
  });
}, { threshold: 0.5 });
observer.observe(video); */
// pdp page video play for arrow when video slider active
jQuery(document).ready(function(){
  // Play video when clicking on Slick arrows
  jQuery('.product__thumbnail').on('click', '.slick-arrow', function(){
      playVideoThumbClickArrow();
  });

  // Play video when clicking on a thumbnail
  jQuery('.product__thumbnail').on('click', '.thumbnail-selector-class', function(){
      playVideoThumbClickArrow();
  });
});
// Function to play the video on the active slide
function playVideoThumbClickArrow(){
  setTimeout(function(){
    // Get the active slide's video and play it if it exists
    var activeVideo = jQuery('.product__gallery').find('.slick-current.slick-active').find('video');
    if (activeVideo.length) { // Ensure there's a video element
        jQuery('.product__gallery').find('.slick-current.slick-active').find('.deferred-media__poster-button').hide();
        activeVideo[0].play(); // Play the video
    }
  }, 1000); // Adjust the delay as per your carousel transition timing
}

jQuery(function(){
  createSticky(jQuery('.section-header'));
});

function createSticky(sticky) {

    if (typeof sticky !== "undefined") {

        var pos = sticky.offset().top,
                win = jQuery(window);

        win.on("scroll", function() {
            if(win.scrollTop()==pos){
                sticky.removeClass("fixed");                
            }else{
            win.scrollTop() >= pos ? sticky.addClass("fixed") : sticky.removeClass("fixed");      
            }
        });         
    }
}

/* age verified script ----------- --------- ----- :: START ::

jQuery(document).ready(function() {
  function checkAgeVerification() {
    const currentTime = new Date().getTime();
    const lastVerifiedTime = localStorage.getItem('ageVerifiedTime');
    
    // Check if the user has verified their age before and if 1 hour has passed
    if (!lastVerifiedTime || (currentTime - lastVerifiedTime) > 60 * 60 * 1000) {
        jQuery('.agechecker-modal').css('display', 'flex');
    } else {
        console.log('User already verified within the last 1 hour');
    }
  }

  // Run the check once when the page loads
  checkAgeVerification();

  // Handle the "Yes" button click
  jQuery('#yes-button').on('click', function() {
      const currentTime = new Date().getTime(); // Get current time at the moment of click
      localStorage.setItem('ageVerifiedTime', currentTime);
      localStorage.setItem('ageVerified', 'true');

      jQuery('.agechecker-modal').hide();
  });

  // Handle the "No" button click
  jQuery('#no-button').on('click', function() {
      alert("Sorry, you must be 21 or older to access this site.");
  });

  // Optional: Set an interval to check every 1 hour (3600000 milliseconds)
  setInterval(checkAgeVerification, 60 * 60 * 1000); // Check every 1 hour
});


// jQuery(document).ready(function() {
//     const currentTime = new Date().getTime();
//     const lastVerifiedTime = localStorage.getItem('ageVerifiedTime');
//     // Check if the user has verified their age before and if 1 hour has passed
//     if (!lastVerifiedTime || (currentTime - lastVerifiedTime) > 60 * 60 * 1000) {
//         jQuery('.agechecker-modal').css('display', 'flex');
//     } else {
//         console.log('User already verified within the last 1 hours');
//     }

//     jQuery('#yes-button').on('click', function() {
//       localStorage.setItem('ageVerifiedTime', currentTime);
//       localStorage.setItem('ageVerified', 'true');

//       jQuery('.agechecker-modal').hide();
//     });

//     jQuery('#no-button').on('click', function() {
//         alert("Sorry, you must be 21 or older to access this site.");
//     });
// });

// for enter button code
jQuery(document).ready(function () {
  var ageVerified = localStorage.getItem('ageVerified');
  var now = new Date().getTime();

  // Check if the user has verified their age and if 24 hours have passed
  if (!ageVerified || now > ageVerified) {
    // Show the age verification popup if no verification or 24 hours have passed
    jQuery('.agechecker-modal').css('display', 'flex');
  } else {
    // Hide the popup if the user is still within the 24-hour verification period
    jQuery('.agechecker-modal').css('display', 'none');
  }

  // Function to check if the user is 21 years old
  function isUser21(birthMonth, birthDay, birthYear) {
    var today = new Date();
    var birthDate = new Date(birthYear, birthMonth - 1, birthDay);
    var age = today.getFullYear() - birthDate.getFullYear();
    var monthDifference = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age >= 21;
  }

  // Handle "Enter" button click
  jQuery('#enter-button').click(function () {
    var birthMonth = jQuery('#birthmonth').val();
    var birthDay = jQuery('#birthday').val();
    var birthYear = jQuery('#birthyear').val();

    if (birthMonth.length === 2 && birthDay.length === 2 && birthYear.length === 4) {
      if (isUser21(birthMonth, birthDay, birthYear)) {
        // If user is 21 or older, set a timestamp 1 hours from now
        var expirationTime = new Date().getTime() + (60 * 60 * 1000); // 1 hours in milliseconds
        localStorage.setItem('ageVerified', expirationTime);

        // Hide the popup and allow access to the site
        jQuery('.agechecker-modal').css('display', 'none');
      } else {
        alert("You must be 21 or older to access this site.");
      }
    } else {
      alert("Please fill in all date fields.");
    }
  });

  // Handle "No, I'm under 21" button click
  jQuery('#no-button').click(function () {
    alert("Sorry, you must be 21 or older to access this site.");
    // Keep the popup open
    jQuery('.agechecker-modal').css('display', 'flex');
  });
});

*/
// age verified script ----------- --------- ------- :: END ::


// age verification ROMAN
jQuery(document).ready(function () {
  function checkAgeVerification() {
    const currentTime = new Date().getTime();
    const lastVerifiedTime = parseInt(localStorage.getItem('ageVerifiedTime'), 10); // Parse it to an integer

    // Check if 3 minutes have passed since last verification
    if (!lastVerifiedTime || (currentTime - lastVerifiedTime) > 60 * 60 * 1000) { // 3 minutes in milliseconds
      jQuery('.agechecker-modal').css('display', 'flex');
    } else {
      console.log('User already verified within the last 3 minutes');
    }
  }

  // Run the check once when the page loads
  checkAgeVerification();

  // Handle the "Yes" button click
  jQuery('#yes-button').on('click', function () {
    const currentTime = new Date().getTime(); // Get current time at the moment of click
    localStorage.setItem('ageVerifiedTime', currentTime.toString()); // Save it as a string
    localStorage.setItem('ageVerified', 'true');

    jQuery('.agechecker-modal').hide();
  });

  // Handle the "No" button click
  jQuery('#no-button').on('click', function () {
    alert("Sorry, you must be 21 or older to access this site.");
  });

  // Optional: Set an interval to check every 3 minutes (180000 milliseconds)
  setInterval(checkAgeVerification, 60 * 60 * 1000); // Check every 3 minutes

  // Handle "Enter" button click
  jQuery('#enter-button').click(function () {
    var birthMonth = jQuery('#birthmonth').val();
    var birthDay = jQuery('#birthday').val();
    var birthYear = jQuery('#birthyear').val();

    if (birthMonth.length === 2 && birthDay.length === 2 && birthYear.length === 4) {
      if (isUser21(birthMonth, birthDay, birthYear)) {
        // If user is 21 or older, set a timestamp 3 minutes from now
        var expirationTime = new Date().getTime() + (60 * 60 * 1000); // 3 minutes in milliseconds
        localStorage.setItem('ageVerifiedTime', expirationTime.toString()); // Save it as a string
        localStorage.setItem('ageVerified', 'true');

        // Hide the popup and allow access to the site
        jQuery('.agechecker-modal').css('display', 'none');
      } else {
        alert("You must be 21 or older to access this site.");
      }
    } else {
      alert("Please fill in all date fields.");
    }
  });

  // Handle "No, I'm under 21" button click
  jQuery('#no-button').click(function () {
    alert("Sorry, you must be 21 or older to access this site.");
    // Keep the popup open
    jQuery('.agechecker-modal').css('display', 'flex');
  });

  // Function to check if the user is 21 years old
  function isUser21(birthMonth, birthDay, birthYear) {
    var today = new Date();
    var birthDate = new Date(birthYear, birthMonth - 1, birthDay);
    var age = today.getFullYear() - birthDate.getFullYear();
    var monthDifference = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age >= 21;
  }
});


$(document).ready(function() {
    // Play the video when mouse enters the element
    $('li.grid__item .product-card-wrapper').on('mouseenter', function() {
        $(this).find('.featured-video').get(0).play(); // Play the video
    });

    // Pause the video when mouse leaves the element
    $('li.grid__item .product-card-wrapper').on('mouseleave', function() {
        $(this).find('.featured-video').get(0).pause(); // Pause the video
        $(this).find('.featured-video').get(0).currentTime = 0; // Reset video to the start (optional)
    });
});